"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const a=require("./index88.js"),s=require("./index90.js");var d=a.shared,t=s.uid,r=d("keys"),u=function(e){return r[e]||(r[e]=t(e))};exports.sharedKey=u;
